import React, { useState } from "react";
import { toasterState } from "Components/common/toaster";

const ShareRecordingModal = ({ shareUrl, onClose, contactName, memberName, duration, callDate }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toasterState.setToastMsg("Link copied to clipboard", "success");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      toasterState.setToastMsg("Failed to copy link", "failure");
    }
  };

  return (
    <div className="shareRecordingOverlay" onClick={onClose}>
      <div className="shareRecordingModal" onClick={e => e.stopPropagation()}>
        <div className="shareRecordingModalHeader">
          <div>
            <span className="shareRecordingModalTitle">Share call recording</span>
            <div className="shareRecordingModalMeta">
              {contactName && <span className="shareRecordingModalMetaName">{contactName}</span>}
              {callDate && <span className="shareRecordingModalMetaDot">·</span>}
              {callDate && <span>{callDate}</span>}
              {duration && <span className="shareRecordingModalMetaDot">·</span>}
              {duration && <span>{duration}</span>}
            </div>
          </div>
          <button className="shareRecordingModalClose" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>
        <div className="shareRecordingModalBody">
          <p className="shareRecordingModalSectionLabel">PUBLIC LINK</p>
          <div className="shareRecordingLinkRow">
            <div className="shareRecordingLinkInputWrapper">
              <i className="material-icons shareRecordingLinkIcon">link</i>
              <input
                className="shareRecordingLinkInput"
                type="text"
                value={shareUrl}
                readOnly
                onClick={e => e.target.select()}
              />
            </div>
            <button className="shareRecordingCopyBtn" onClick={handleCopy}>
              <i className="material-icons">{copied ? "check" : "content_copy"}</i>
              {copied ? "Copied" : "Copy link"}
            </button>
          </div>
          <p className="shareRecordingModalDesc">
            Anyone with this link can listen to the recording. No login required.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShareRecordingModal;
